import * as basket from "../eaiws/basket";
import { getDefaultGetArticleDataOptions } from "./Defaults";
export async function getArticleData(pSession, pItemId, pCacheData, pOptions) {
    const tRequestedOptions = pOptions !== null && pOptions !== void 0 ? pOptions : getDefaultGetArticleDataOptions();
    tRequestedOptions.separateCurrencies = true; //force to be true
    //check cache first
    const tArticleData = getCachedArticleData(tRequestedOptions, pCacheData);
    if (tArticleData != null)
        return (Promise.resolve(tArticleData));
    let tPromise = pSession.basket.getArticleData(pItemId, tRequestedOptions);
    tPromise = tPromise.then((pArticleData) => {
        const tCachedOptions = pCacheData.articleDataOptions;
        const tCachedData = pCacheData.articleData;
        if (tCachedOptions == null || tCachedData == null) {
            //nothing cached yet, add entry
            const tOptions = new basket.GetArticleDataOptions();
            Object.assign(tOptions, tRequestedOptions); //create copy
            pCacheData.articleData = pArticleData;
            pCacheData.articleDataOptions = tOptions;
        }
        else {
            //update cached articledata
            if (pArticleData != null) {
                //properties
                if (!tRequestedOptions.noProperties) {
                    tCachedOptions.noProperties = false;
                    tCachedData.properties = pArticleData.properties;
                    tCachedData.propertyClasses = pArticleData.propertyClasses;
                }
                //catalog icon
                if (tRequestedOptions.fetchCatalogIcon) {
                    tCachedOptions.fetchCatalogIcon = true;
                    tCachedData.catalogIcon = pArticleData.catalogIcon;
                }
                //catalog image
                if (tRequestedOptions.fetchCatalogImage) {
                    tCachedOptions.fetchCatalogImage = true;
                    tCachedData.catalogImage = pArticleData.catalogImage;
                }
            }
        }
        return (pArticleData);
    });
    return (tPromise);
}
export function getCachedArticleData(pOptions, pCacheData) {
    let tRequestedOptions = pOptions;
    if (tRequestedOptions == null)
        tRequestedOptions = getDefaultGetArticleDataOptions();
    if (pCacheData == null || pCacheData.articleDataOptions == null)
        return (undefined); //nothing cached
    //compare cached with requested options
    const tCachedOptions = pCacheData.articleDataOptions;
    if (tCachedOptions == null)
        return (undefined); //nothing cached
    //properties not cached
    if (tCachedOptions.noProperties && !tRequestedOptions.noProperties)
        return (undefined);
    //icon not cached
    if (!tCachedOptions.fetchCatalogIcon && tRequestedOptions.fetchCatalogIcon)
        return (undefined);
    //image not cached
    if (!tCachedOptions.fetchCatalogImage && tRequestedOptions.fetchCatalogImage)
        return (undefined);
    return (pCacheData.articleData);
}
